import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const ScenarioModeling = () => {
    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.scenario-modeling-spork.title"
                    defaultMessage="Scenario modeling"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.scenario-modeling-spork.bodyOne"
                    defaultMessage="Scenarios allow you to explore alternative paths for your plan, such as best case and worst case. This allows you to quickly assess the downstream impact and tradeoffs before committing to changes."
                />
            </p>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.scenario-modeling-spork.learnMore"
                    defaultMessage="<learnMore>Learn more</learnMore> about scenarios."
                    values={{
                        ...DEFAULT_VALUES,
                        learnMore: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="jiraSoftware"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={useLocalizedHref(
                                    "/software/jira/guides/advanced-roadmaps/overview#how-do-i-plan-for-different-scenarios"
                                )}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export default ScenarioModeling;
